import { useReducer } from 'react';
import { customTableReducer } from '../../../../../hooks/tableHook';
import { DC } from './variables';

export const useProductsReducer = ({
  initialSearchParams,
  resetSearchParams,
}) => {
  const [searchParams, dispatch] = useReducer(
    customTableReducer({ resetSearchParams, customReducer }),
    initialSearchParams
  );
  return [searchParams, dispatch];
};

const customReducer = (state, { type, payload }) => {
  switch (type) {
    case DC.PRODUCT_STATUS:
    case DC.CUSTOMER:
    case DC.PRODUCT_CATEGORY:
    case DC.LOCATION:
    case DC.ACTOR_DATA:
      return {
        ...state,
        [type]: [...payload],
        [DC.FILTERS_SET]: true,
      };
    default:
      return state;
  }
};
